import { IListItem } from '@nkr/models/index';

export interface IDonationTypeData {
    show: boolean,
    donorId: number,
    isPaired: boolean,
    hasIntended: boolean,
    isExpertSystem: boolean,
    hasDashReferral: boolean,
    typeList: IListItem[],
}

export const initialDonationTypeDataState: IDonationTypeData = {
    show: false,
    donorId: 0,
    isPaired: false,
    hasIntended: false,
    isExpertSystem: false,
    hasDashReferral: false,
    typeList: []
};